<template lang="pug">
#leads-page.grid-box.grid-col
    filterHeader(
	:active-toggle-main="activeToggleMain" 
	:active-toggle-three="activeToggleThree"
	@sort-changed="handleSortChanged")
    .page-content.grid-box.grid-row
        .left-col.grid-box.grid-col
            .list.grid-box.grid-col.scroll-y(:class="{'loading': loading}")
                .loading-container(v-if="loading")
                    .loading-circle
                template(v-if="!loading")
                    .split-list-item.grid-con.grid-col(
                        v-for="item in leadsList"
                        :key="item._id"
                        :class="{active: (currentItem._id == item._id || selectedItem?._id == item._id)}"
                        @click="selectItem(item)"
                    )
                        div.text {{ resolveName(item) }}
                        div.text {{ item.email || "Email" }}
                        div.grid-con.row.grid-row
                            span.text {{ item.lastContact || "Today" }}
                            span.text {{ item.phone || "Phone" }}
            button.icon.secondary(@click="createNewLead")
                include ../../../library/src/resources/icons/add.pug
                span New Lead
        .selected-item.grid-col.scroll-y
            LeadsDetails(
                :email = "email"
                :interest = "interest"
                :check-status="checkStatus"
                :lead-item="currentItem"
                :loading="loading"
                :error-messages="errorMessages"
                @create-cust-acct="createNewCustomer"
            )
            button.primary.outline(@click="clickSave") Save Changes
</template>
<script lang="ts" setup>
import {ref, onMounted, computed,Ref, watch } from "vue";
import { CONSTANTS, Leads } from "@busy-human/k9-library";
import { useLeads, Lead, LeadModel } from "@/store/useLeads";
import { useAppState } from "@/store/useAppState";
import {leadToCustomer} from "@/util/lead-to-customer";
import LeadsDetails from "../components/leads-details.vue";
import filterHeader from '../components/filter-header.vue';

const minEmailLength = 4;

const appState      = useAppState();
const leadsStore    =    useLeads();

const checkStatus = ref(true);
const error       = ref('');
const email       = ref('');
const interest    = ref('');

const loading       = computed(()=> appState.loading      );
const leadsList = computed(() => leadsStore.leadsList);
const selectedItem  = computed(()=>leadsStore.selectedItem);

const activeToggleMain = ref(false);
const activeToggleThree = ref(false);

const updateCurrentItem = (input={}) => {
	if (Object.hasOwn(input,"_id")){
		return {...input};
	}else{
		return Object.assign(Leads.Defaults(),selectedItem.value);
	}
};

const currentItem = ref<LeadModel>(updateCurrentItem());

const createNewLead = () => {
	leadsStore.createNewTempLead();
	console.log(" Leads store list: ", leadsStore.leadsList);
	currentItem.value = updateCurrentItem();
};

/* UI Messages */
const uiMessage = ref<any>("");
/* Error messages for inputs. - Example: "Email should not be blank" */
const errorMessages: Ref<{
	[key: string]: string,
}> =  ref({
	email: "",
});

/* Ensure Vue receives some sort of string */
const resolveName = (item: Lead) =>
	item?.name?.fullName
	|| `${item?.name?.firstName} ${item?.name?.lastName}`
	|| item?._id
	|| "Name";

const checkClosed = ( ) => {
	if(currentItem.value.status === CONSTANTS.STATUS.ClosedCustomer || currentItem.value.status === CONSTANTS.STATUS.ClosedNoSale) {
		checkStatus.value = false;
	} else {
		checkStatus.value = true;
	}
};

/* Convert Unix time to a UI friendly format */
// function convertTime(date: any){
// 	const contactDate = new Date(date*1000);
// 	date = contactDate;
// }
const clickSave = () => {
	console.group("Click Save ", currentItem.value, selectedItem.value);
	// leadsStore.updateSelectedItem(currentItem.value);
	/* Only save if item has any content and if item has changed */
	if( !leadsStore.isItemEmpty(currentItem.value)
		// && leadsStore.isItemDirty(currentItem.value)
	){
		appState.setLoading();
		leadsStore.updateSelectedItem(currentItem.value);
		leadsStore.saveItem().then((res:any)=>{
			if (res) {
				if (res.success === true) {
					/*TODO: -- Do a toast, to alert user of Sucess :) */
					uiMessage.value = "Saved Successfully";
				} else {
					/*TODO: -- Show error message, and what went wrong :(  */
					console.error("Error on 'clickSave' ", res, "\nReason: ", res.reason);
				}
			} else {console.error(" No response from leadsStore.saveItem...");};
		}).then(()=>updateCurrentItem());
	};
	console.groupEnd();
};

/** Create new customer from lead (currentItem that's selected) */
const createNewCustomer = (idArg: string) => {
	const leadId = idArg || selectedItem.value._id || selectedItem.value.$id || "";
	console.group(" Create New Customer ");
	console.log( " leads.vue, createNewCustomer called. For lead with id: ", leadId);
	/* There Must be an email set, else account is unable to be set up */
	if(!!currentItem.value.email && currentItem.value.email.length > minEmailLength){
		if(leadsStore.itemDirty) clickSave();
		leadToCustomer(leadId).then((res:any)=>{
			if (res && res.success){
				console.log( " Success!! ", res);
				currentItem.value.status = CONSTANTS.STATUS.ClosedCustomer;
				clickSave();
			} else {
				console.log( " Failure!! ", res.message);
				console.log( " Tried to create new customer, but failed: \n",res);
				error.value = res.message;
				console.log("Error is:", error.value);
				// TODO: 1/17/23: fix alert and remove next line
				// eslint-disable-next-line no-alert
				alert(error.value);
			}

		});
	} else {
		errorMessages.value.email = "Email address is required";
	}
	console.groupEnd();
};

const selectItem = (item: Lead )=>{
	if (currentItem.value._id !== item._id){
		console.log("Has Item been changed? ", leadsStore.itemDirty, leadsStore.isItemDirty(currentItem.value));
		if(leadsStore.itemDirty){
			clickSave();
		}
		leadsStore.selectItem(item);
		currentItem.value = updateCurrentItem();
		console.log("Current item is:", currentItem.value);
		email.value = currentItem.value.email;
		interest.value = currentItem.value.productInterest;
		checkClosed();
	};
};

const handleSortChanged = (sortedList: any[]) => {
	leadsStore.setLeadsList(sortedList);
};

const sortLeads = () => {
	const result = [...leadsList.value];
  
	if (activeToggleMain.value) {
		// Sort by Date
		result.sort((a, b) => new Date(b.lastContact).getTime() - new Date(a.lastContact).getTime());
	} else {
		// Sort by Name
		result.sort((a, b) => a.name.fullName.toLowerCase().localeCompare(b.name.fullName.toLowerCase()));
	}

	if (activeToggleThree.value) {
		// Reverse the order (Ascending / Descending)
		result.reverse();
	}

	leadsStore.setLeadsList(result);
};

onMounted(async () => {
	await leadsStore.fetchLeads();
	sortLeads();
});

</script>

<style lang="scss">
/* Moved all the SCSS to stylesheets/leads-page.scss :) */
</style>